import { Component, Input } from '@angular/core';
import { NavigateParams } from 'src/app/model/navigate-params';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss']
})
export class SubHeaderComponent {
  @Input() navigateParams:NavigateParams | undefined;
}
